import { RegisterExplanationModal } from '@common/components/registration-explanation-modal';
import { Button } from '@konova/ui/button';
import {
  ConfirmationCard,
  ConfirmationCardFooter,
  ConfirmationCardIcon,
  ConfirmationCardTitle
} from '@konova/ui/confirmation-card';
import { Icon } from '@konova/ui/icon';
import { Stack } from '@konova/ui/stack';
import { Typography } from '@konova/ui/typography';
import clsx from 'clsx';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import classes from './registration-required-content.module.scss';

export type RegistrationRequiredDisplayProps = {
  /**
   * The URL used for login functionality.
   */
  loginUrl?: string;
  /**
   * Callback function for the event when the "Login" button is clicked.
   * This function has no parameters and does not return any value.
   */
  onLoginClicked?: () => void;
};

export const RegistrationRequiredContent: FC<RegistrationRequiredDisplayProps> = ({
  loginUrl = '/',
  onLoginClicked,
}) => {
  const [t] = useTranslation();
  const [showExplanation, setShowExplanation] = useState(false);

  return (
    <>
      <RegisterExplanationModal
        show={showExplanation}
        onClose={() => setShowExplanation(false)}
      />
      <Stack
        direction="row"
        fill
        crossAxis="center"
        data-testid={'registration-required-content'}
        className={clsx(classes.root, 'registration-required-display-component')}
      >
        <ConfirmationCard
          elevation={false}
          className={classes.card}
          classes={{
            content: classes.contentWrapper,
          }}
          icon={<ConfirmationCardIcon color="primary.main" icon="lock-alt" />}
        >
          <Stack direction="column" fill crossAxis="center" spacing={3}>
            <ConfirmationCardTitle>
              {t('pages.login.index.form.overlay-title')}
            </ConfirmationCardTitle>

            <Typography center>
              {t('pages.login.index.form.overlay-description')}
            </Typography>
          </Stack>

          <ConfirmationCardFooter>
            <Button as={Link} to={loginUrl} onClick={onLoginClicked}>
              {t('pages.login.register.login-now')}
            </Button>
            <Button
              prefix={<Icon icon={['far', 'exclamation-circle']} />}
              variant="text"
              typoProps={{
                className: classes.explanationLabel,
              }}
              onClick={() => setShowExplanation(true)}
            >
              {t('pages.login.index.form.why-register-link')}
            </Button>
          </ConfirmationCardFooter>
        </ConfirmationCard>
      </Stack>
    </>
  );
};